export const toggleFeaturedAllergy = (allergy, state) => {
  if (!findAllergyInState(allergy, state)) {
    return [...state, allergy];
  }
  return state.filter(a => a.value !== allergy.value);
};

export const findAllergyInState = (allergy, state) =>
  state?.find(a => a.value === allergy.value);

export const normalize = allergies =>
  allergies.map(allergy => ({
    label: allergy.name,
    value: allergy.id,
  }));

export const getPlaceholderAllergies = (count = 8) =>
  Array.from({ length: count }, (val, idx) => ({
    ...val,
    name: 'Loading',
    id: `Loading-${idx}`,
  }));
